export default __webpack_public_path__ + "static/media/avatar.f4eb2a3e.jpeg";